export default {
  newRecipe: 'New recipe',
  protectedTooltip: 'This recipe can not be altered because it is protected.',
};
